const BASE_ASSETS_URL = 'https://kyte-assets.s3.us-west-1.amazonaws.com';
const BASE_CONSUMER_ASSETS_URL = `${BASE_ASSETS_URL}/consumer-assets`;

export { BASE_CONSUMER_ASSETS_URL as B };
//# sourceMappingURL=global-2e5d81b9.js.map
